export enum ReactQuery {
    RETRY_DELAY = 3000,
}